import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import logo from "../../assets/images/logo.png"
import SidebarContent from "./SidebarContent"
import { Link } from "react-router-dom"
import React from "react"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/dashboard" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" width="40px" />
            </span>
            <span className="logo-lg">
              <h4
                className="pt-4 pb-1 text-start"
                style={{
                  font: "Archivo",
                  fontWeight: "800",
                  fontStyle: "italic",
                  fontSize: "25px",
                  color: "#00578E",
                  lineHeight: "13px",
                  letterSpacing: "0.5px",
                  marginLeft: "4px",
                }}
              >
                <img
                  src={logo}
                  alt=""
                  width="40px"
                  style={{ marginRight: "8px" }}
                />
                Supplier
              </h4>
            </span>
          </Link>
          <Link to="/dashboard" className="logo logo-light">
            <span className="logo-sm">
              <img src={logo} alt="" width="40px" />
            </span>
            <span className="logo-lg">
              <h4
                className="pt-4 pb-1"
                style={{
                  font: "Archivo",
                  fontWeight: "800",
                  fontStyle: "italic",
                  fontSize: "25px",
                  color: "#00578E",
                  lineHeight: "13px",
                  letterSpacing: "0.5px",
                }}
              >
                <img
                  src={logo}
                  alt=""
                  width="40px"
                  style={{ marginRight: "8px" }}
                />
                Supplier
              </h4>
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
